import { FC } from 'react';
import { ActiveCrmDataSource, PendingCrmDataSource } from './crm';
import { OverviewTabProps } from './types/types';

export const CrmOverview: FC<OverviewTabProps> = ({ dataSource, isActive }) => {
  return <>{isActive ? <ActiveCrmDataSource dataSource={dataSource} /> : <PendingCrmDataSource dataSource={dataSource} />}</>;
};
